module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0f0aeaa06e0b2f4aaa5c52d582468c0b.png";